import { array, intersect, partial, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as OrganizationId } from '../../../../organization/Id';
import { Id as PropertyType } from '../../../../whole-house/material/property-type';
import { Id as UsageId } from '../../../../whole-house/usage/Id';

export const Request = intersect(
	struct({
		organizationId: OrganizationId,
		materialTemplateRef: iotsUtils.NotEmptyString,
		propertyTypes: array(PropertyType),
	})
)(
	partial({
		usages: array(UsageId),
	})
);
